export default "__VITE_PUBLIC_ASSET__5532071e__"